import { Box, Typography } from '@mui/material';
import React from 'react';

import {
  RecordContextProvider, ReferenceField, TextField,
  usePermissions,
} from 'react-admin';
import { Rule } from '../../../../utilities/schemas/rules';
import mapRuleParamsShortSummary from '../../ruleFeatures/mapRuleParamsShortSummary';
import hasAccess from '../../../../utilities/hasAccess';
import actions, { Actions } from '../../../../constants/actions';
import PermissionMissing from '../../../utils/PermissionMissing';

const InfoField = ({
  title,
  value,
}: {
  title: string;
  value: string | number;
}) => (
  <Box display="flex" gap={1}>
    <Typography fontWeight="bold" fontSize={10}>{title}</Typography>
    <Typography fontSize={10}>{value}</Typography>
  </Box>
);

const SubTitle = ({
  rule,
}: {
  rule: Rule;
}) => {
  const { permissions } = usePermissions<Actions[]>();
  if (!rule) return null;

  return (
    <RecordContextProvider value={rule}>
      <Box gap={1} display="flex" alignItems="baseline">
        <Box display="flex" gap={1} alignItems="baseline">
          <Typography fontWeight="bold" fontSize={10}>Process</Typography>
          {hasAccess(permissions, actions.PROCESS_LIST) ? (
            <ReferenceField source="process" reference="processes" emptyText="">
              <TextField sx={{ fontSize: 10 }} source="name" />
            </ReferenceField>
          ) : <PermissionMissing /> }
        </Box>
        {rule.createPing && <InfoField title="Score" value={rule.score} />}
        <InfoField title="Create ping" value={rule.createPing ? 'Yes' : 'No'} />
        {React.createElement(mapRuleParamsShortSummary[rule.name], { rule })}
      </Box>
    </RecordContextProvider>
  );
};

export default SubTitle;
